import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Btn, H4 } from '../../../../AbstractElements';
import { Card, CardBody, Col, Table, Form, FormGroup, Label, Row, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Spinner, CardHeader } from 'reactstrap';
import axios from 'axios';
import config from '../../../../config';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx-js-style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import ReactPaginate from 'react-paginate';

const MTDReportView = () => {

    if (localStorage.getItem("accessReports") !== "1") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1; // 1-12
    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_access = localStorage.getItem("propertyAccess");
    const [propertyAccessNames, setPropertyAccesssNames] = useState('');
    const login_name = localStorage.getItem("loginName");
    const login_id = localStorage.getItem("loginId");
    const [year, setYear] = useState(currentYear);
    const [month, setMonth] = useState(currentMonth);
    const [properties, setProperties] = useState([]);
    const [categories, setCategories] = useState([]);
    const [allSubcategories, setAllSubcategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [group_name, setGroupName] = useState('');
    const [groups, setGroups] = useState([]);
    const [allTenants, setAllTenants] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [allFloors, setAllFloors] = useState([]);
    const [floors, setFloors] = useState([]);
    const [property_mall_code, setPropertyMallCode] = useState('');
    const [property_id, setPropertyId] = useState('');
    const [category_id, setCategoryId] = useState('');
    const [subcategory_id, setSubcategoryId] = useState('');
    const [tenant_id, setTenantId] = useState('');
    const [selectedFloor, setSelectedFloor] = useState('');
    const [reportData, setReportData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const today = new Date().toISOString().split('T')[0];
    const token = localStorage.getItem("sessiontoken");
    const [tooltip, setTooltip] = useState('');
    const [itemsPerPage] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

    const handleMouseEnter = (text) => setTooltip(text);
    const handleMouseLeave = () => setTooltip('');

    const [selectedTenants, setSelectedTenants] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const dropdownRef = useRef(null);
    const [searchTenant, setSearchTenant] = useState('');

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };


    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    const selectedPropertyName = React.useMemo(() => {
        if (property_id === '') return '';
        const selectedProperty = properties.find(property => property._id === property_id);
        return selectedProperty ? selectedProperty.property_name : '';
    }, [property_id, properties]);

    const filteredReportData = React.useMemo(() => {
        if (selectedPropertyName === '') return reportData;
        return reportData.filter(item =>
            item.property_name === selectedPropertyName ||
            (property_mall_code !== '' && item.mall_code === property_mall_code)
        );
    }, [reportData, selectedPropertyName, property_mall_code]);

    const dateColumns = React.useMemo(() => {
        const dateSet = new Set();

        filteredReportData.forEach(item => {
            if (item.transactions) {
                item.transactions.forEach(txn => {
                    const date = new Date(txn.transaction_date)
                        .toISOString()
                        .split('T')[0];
                    dateSet.add(date);
                });
            }
        });

        return Array.from(dateSet).sort(); // sorted dates
    }, [filteredReportData]);

    // 🔽 Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);



    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getpropertybyconcessionaire`, { property_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setProperties(response.data);
                const propertyNames = response.data.map(property => property.property_name).join(',');
                setPropertyAccesssNames(propertyNames);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);



    useEffect(() => {
        axios
            .post(`${config.hostname}/category/getcategorybyconcessionaire`, { category_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setCategories(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/subcategory/getsubcategorybyconcessionaire`, { subcategory_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setAllSubcategories(response.data);
                setSubcategories(response.data); // Initial set to all subcategories
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredSubcategories = allSubcategories;

        if (category_id !== '') {
            filteredSubcategories = filteredSubcategories.filter(subcategory => subcategory.category_id._id === category_id);
        }

        setSubcategories(filteredSubcategories);
    }, [category_id]);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getgroupnames`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setGroups(response.data)
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getenantsbyconcessionaire`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllTenants(response.data);
                setTenants(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredTenants = allTenants;

        if (group_name !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_group_name === group_name);
        }

        if (category_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_category_id._id === category_id);
        }

        if (property_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_property_id._id === property_id);
        }

        if (subcategory_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_subcategory_id._id === subcategory_id);
        }

        setTenants(filteredTenants);
    }, [group_name, property_id, category_id, subcategory_id, allTenants]);

    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getfloorsbyconcessionaire`, { concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllFloors(response.data);
                setFloors(getUniqueFloors(response.data));
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredFloors = allFloors;

        if (property_id !== '') {
            filteredFloors = filteredFloors.filter(floor => floor.property_id === property_id);
        }

        setFloors(getUniqueFloors(filteredFloors));
    }, [property_id]);

    const getUniqueFloors = (floors) => {
        const floorNames = new Set();
        return floors.filter(floor => {
            if (!floorNames.has(floor.floor_id.floor_name)) {
                floorNames.add(floor.floor_id.floor_name);
                return true;
            }
            return false;
        });
    };

    const filteredTenants = tenants.filter((tenant) => {
        if (!searchTenant.trim()) return true;

        const search = searchTenant.trim().toLowerCase();

        const name = (tenant.tenant_store_name || "").toLowerCase();
        const code = (tenant.tenant_code || "").toLowerCase(); // or tenant.tenant_code / tenant_code

        return name.includes(search) || code.includes(search);
    });

    const yearOptions = [];
    for (let y = currentYear; y >= currentYear - 4; y--) {
        yearOptions.push(y);
    }

    const monthOptions = [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' },
    ];

    const handleYearChange = (e) => {
        setYear(Number(e.target.value));
        setReportData([]);
        setCurrentPage(0);
    };

    const handleMonthChange = (e) => {
        setMonth(Number(e.target.value));
        setReportData([]);
        setCurrentPage(0);
    };

    const handlePropertyChange = (e) => {
        const selectedProperty = properties.find(property => property._id === e.target.value);
        setPropertyMallCode(selectedProperty ? selectedProperty.property_mall_code : '');
        setPropertyId(e.target.value);
        setTenantId('')
        setSelectedTenants([])
        setSelectedFloor('')
        setReportData([]);
        setCurrentPage(0);
    };

    const handleCategoryChange = (e) => {
        setCategoryId(e.target.value);
        setSubcategoryId('')
        setTenantId('');
        setSelectedTenants([])
        setReportData([]);
        setCurrentPage(0);
    };

    const handleSubCategoryChange = (e) => {
        setSubcategoryId(e.target.value);
        setReportData([]);
        setCurrentPage(0);
    };

    const handleGroupChange = (e) => {
        setGroupName(e.target.value);
        setTenantId('');
        setSelectedTenants([])
    };

    const handleTenantChange = (e) => {
        // setTenantId(e.target.value);
        const value = e.target.value;
        if (selectedTenants.includes(value)) {
            setSelectedTenants(selectedTenants.filter(item => item !== value));
        } else {
            setSelectedTenants([...selectedTenants, value]);
        }

        setReportData([]);
        setCurrentPage(0);
    };

    const handleFloorChange = (e) => {
        setSelectedFloor(e.target.value);
        setReportData([]);
        setCurrentPage(0);
    };

    const insertToLog = (task) => {
        const data = {
            created_by: login_id,
            concessionaire_id: concessionaire_id,
            module: "Reports",
            task: login_name + task
        }
        axios
            .post(`${config.hostname}/log`, data, configheader)
            .then(() => {
                console.log("inserted to log table")
            })
            .catch((error) => {
                toast.error('Error')
                console.log(error);

            });
    }

    const generateReport = async (e) => {
        e.preventDefault();

        const category_name = category_id !== '' ? categories.find(category => category._id === category_id).category_name : '';
        const property_name = property_id !== '' ? properties.find(property => property._id === property_id).property_name : '';
        const subcategory_name = subcategory_id !== '' ? subcategories.find(subcategory => subcategory._id === subcategory_id).subcategory_name : '';


        const data = {
            concessionaire_id,
            property_access: propertyAccessNames,
            year: year,
            month: month,
            group_name,
            category_name,
            property_name,
            subcategory_name,
            tenant_id: selectedTenants,
            floor: selectedFloor
        };

        setLoading(true)
        axios
            .post(`${config.hostname}/reports/getmonthtodatereport`, data, configheader)
            .then((response) => {
                setReportData(response.data);
                setLoading(false)
                insertToLog(" generated MTD report")
                console.log(response.data);
            })
            .catch((error) => {
                toast.error('Error');
                setLoading(false)
                console.log(error);
            });
    }

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    //const offset = currentPage * itemsPerPage;


    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = key => {
        if (sortConfig.key === key) {
            if (sortConfig.direction === 'asc') {
                return <FontAwesomeIcon icon={faSortUp} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
            if (sortConfig.direction === 'desc') {
                return <FontAwesomeIcon icon={faSortDown} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
        }

    };

    const groupedData = filteredReportData.reduce((acc, item) => {
        const key = `${item.tenant_name}-${item.property_name}-${item.outlet_code}-${item.tenant_code}`;

        if (!acc[key]) {
            acc[key] = {
                tenant_name: item.tenant_name,
                property_name: item.property_name,
                mall_code: item.mall_code,
                outlet_code: item.outlet_code,
                tenant_code: item.tenant_code,
                dates: {}
            };
        }

        if (item.transactions) {
            item.transactions.forEach(txn => {
                const date = new Date(txn.transaction_date)
                    .toISOString()
                    .split('T')[0];

                acc[key].dates[date] = {
                    total_net_sales: txn.net_sales || 0
                };
            });
        }

        return acc;
    }, {});

    const formattedData = Object.values(groupedData);

    const sortedReportData = React.useMemo(() => {
        let sortableData = [...formattedData];
        if (sortConfig.key !== '') {
            sortableData.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableData;
    }, [filteredReportData, sortConfig]);

    const currentPageData = sortedReportData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
    const pageCount = Math.ceil(sortedReportData.length / itemsPerPage);



    const exportToExcel = () => {

        const category_name = category_id !== '' ? categories.find(category => category._id === category_id).category_name : '';
        const property_name = property_id !== '' ? properties.find(property => property._id === property_id).property_name : '';
        const subcategory_name = subcategory_id !== '' ? subcategories.find(subcategory => subcategory._id === subcategory_id).subcategory_name : '';

        // Filters header
        const filterDetails = [
            ['Month To Date Sales Report'],
            property_name && [`Property: ${property_name}`],
            category_name && [`Category: ${category_name}`],
            subcategory_name && [`Subcategory: ${subcategory_name}`],
            selectedFloor && [`Floor: ${selectedFloor}`],
            []
        ].filter(Boolean);

        // Table Data
        const tableData = sortedReportData.map((tenant) => {
            const row = [
                tenant.tenant_name,
                tenant.property_name,
                tenant.outlet_code,
                tenant.tenant_code
            ];

            dateColumns.forEach((date) => {
                const value = tenant.dates[date]?.total_net_sales;

                if (value === undefined) {
                    row.push(""); // ✅ IMPORTANT → force cell creation
                } else {
                    row.push(value);
                }
            });

            const total = dateColumns.reduce((total, date) =>
                total + (tenant.dates[date]?.total_net_sales || 0), 0
            );

            row.push(total);
            return row;
        });

        // Headers
        const headers = [
            'Tenant Name',
            'Property',
            'Unit Code',
            'Tenant Code',
            ...dateColumns,
            'Total'
        ];

        const worksheetData = [
            ...filterDetails,
            headers,
            ...tableData
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        const startDataRow = filterDetails.length + 1;
        const monthColStart = 4;
        const monthColEnd = 4 + dateColumns.length;

        // 🎨 Apply formatting + colors
        for (let R = startDataRow; R < worksheetData.length; R++) {
            for (let C = monthColStart; C <= monthColEnd; C++) {

                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                const cell = worksheet[cellAddress];

                if (!cell) continue;

                // Number formatting
                if (typeof cell.v === 'number') {
                    cell.t = 'n';
                    cell.z = '#,##0.00';

                    // 🔴 0 SALES → RED
                    if (cell.v === 0) {
                        cell.s = {
                            fill: {
                                patternType: "solid",
                                fgColor: { rgb: "FFC7CE" }
                            }
                        };
                    }
                }

                // ⚪ MISSING → GREY
                if (cell.v === "" || cell.v === null || cell.v === undefined) {
                    cell.s = {
                        fill: {
                            patternType: "solid",
                            fgColor: { rgb: "FFF2CC" } // 🟡 light yellow
                        }
                    };
                }
            }
        }

        // 📊 Bold header row
        const headerRowIndex = filterDetails.length;
        for (let C = 0; C < headers.length; C++) {
            const cellAddress = XLSX.utils.encode_cell({ r: headerRowIndex, c: C });
            if (worksheet[cellAddress]) {
                worksheet[cellAddress].s = {
                    font: { bold: true }
                };
            }
        }

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "MTD Report");

        XLSX.writeFile(workbook, "MTD_Sales_Report.xlsx");
    };

    const formatCurrency = (value) => {
        if (typeof value !== 'number') return '-';
        return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const reset = () => {
        setYear(currentYear)
        setMonth(currentMonth)
        setPropertyId('');
        setCategoryId('');
        setSubcategoryId('');
        setGroupName('');
        setTenantId('');
        setSelectedTenants([])
        setSearchTenant('');
        setDropdownOpen(false);
        setSelectedFloor('');
        setReportData([]);
        setCurrentPage(0);

    }

    return (
        <Fragment>
            <Form className='theme-form' onSubmit={generateReport}>
                <Card>
                    <CardBody>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="year">Year</Label>
                                    <select name="year" id="year" className="form-control"
                                        value={year} onChange={handleYearChange}>
                                        {yearOptions.map((y) => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="month">Month</Label>
                                    <select name="month" id="month" className="form-control"
                                        value={month} onChange={handleMonthChange}>
                                        {monthOptions.map((m) => (
                                            <option key={m.value} value={m.value}>{m.label}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>

                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="property_id">Property</Label>
                                    <select name="property_id" id="property_id" className="form-control"
                                        value={property_id} onChange={handlePropertyChange}>
                                        <option value="">All</option>
                                        {properties.map(property => (
                                            <option key={property._id} value={property._id}>{property.property_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="category_id">Category</Label>
                                    <select name="category_id" id="category_id" className="form-control"
                                        value={category_id} onChange={handleCategoryChange}>
                                        <option value="">All</option>
                                        {categories.map(category => (
                                            <option key={category._id} value={category._id}>{category.category_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Sub Category</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={subcategory_id} onChange={handleSubCategoryChange}>
                                        <option value="">All</option>
                                        {subcategories.map(subcategory => (
                                            <option key={subcategory._id} value={subcategory._id}>{subcategory.subcategory_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Group</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={group_name} onChange={handleGroupChange}>
                                        <option value="">All</option>
                                        {groups.map((group, index) => (
                                            <option key={index} value={group}>{group}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>

                            <Col>
                                <div style={{ position: 'relative', width: '100%' }} ref={dropdownRef}>
                                    <label>Tenants</label>
                                    <div
                                        onClick={toggleDropdown}
                                        style={{
                                            border: '1px solid #ccc',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div>Select Tenants</div>
                                        <span style={{ marginLeft: 'auto' }}>&#9662;</span>
                                    </div>
                                    {dropdownOpen && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                width: '100%',
                                                backgroundColor: '#fff',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                marginTop: '4px',
                                                zIndex: 1,
                                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                                maxHeight: '250px', // Set the maximum height for the dropdown
                                                overflowY: 'auto' // Scrollable content
                                            }}
                                        >
                                            {/* Search Bar */}
                                            <div style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
                                                <input
                                                    type="text"
                                                    placeholder="Search tenants..."
                                                    value={searchTenant}
                                                    onChange={(e) => setSearchTenant(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '6px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px'
                                                    }}
                                                />
                                            </div>

                                            {/* Filtered Tenants List */}
                                            {filteredTenants.length > 0 ? (
                                                filteredTenants.map(tenant => (
                                                    <label
                                                        key={tenant._id}
                                                        style={{ display: 'block', padding: '8px', cursor: 'pointer' }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            value={tenant._id}
                                                            checked={selectedTenants.includes(tenant._id)}
                                                            onChange={handleTenantChange}
                                                            style={{ marginRight: '8px' }}
                                                        />

                                                        {/* 👇 Display code + name */}
                                                        <span style={{ fontWeight: 500 }}>
                                                            {tenant.tenant_store_name}
                                                            {tenant.tenant_code ? ` - ${tenant.tenant_code}` : ""}
                                                        </span>
                                                    </label>
                                                ))
                                            ) : (
                                                <div style={{ padding: '8px', color: 'gray', textAlign: 'center' }}>
                                                    No results found
                                                </div>
                                            )}

                                        </div>
                                    )}
                                </div>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="tenant_id">Floor</Label>
                                    <select name="tenant_id" id="tenant_id" className="form-control"
                                        value={selectedFloor} onChange={handleFloorChange}>
                                        <option value="">All</option>
                                        {floors.map((floor, index) => (
                                            <option key={index} value={floor.floor_id.floor_name}>{floor.floor_id.floor_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col >
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', type: "submit" }} >Generate Report</Btn>
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', onClick: reset }} >Reset</Btn>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <Card>
                    {loading === true ? (
                        <div className="loader-box">
                            <Spinner attrSpinner={{ className: 'loader-3' }} />
                        </div>

                    ) : (
                        <Card>
                            <CardHeader>
                                <Row className="justify-content-end">
                                    <Col xs="auto" style={{ position: 'relative' }}>
                                        <Btn
                                            attrBtn={{
                                                color: 'primary',
                                                type: 'button',
                                                onClick: () => exportToExcel(),
                                                onMouseEnter: () => handleMouseEnter('Export to Excel'),
                                                onMouseLeave: handleMouseLeave
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faFileExcel} size="lg" />
                                        </Btn>
                                        {tooltip === 'Export to Excel' && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '-30px',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                backgroundColor: 'black',
                                                color: 'white',
                                                padding: '5px 10px',
                                                borderRadius: '3px',
                                                whiteSpace: 'nowrap',
                                                fontSize: '12px',
                                                zIndex: 1,
                                            }}>
                                                {tooltip}
                                            </div>
                                        )}
                                    </Col>

                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Col sm="12" lg="12" xl="12">
                                    <div className="table-responsive" >
                                        <Table>
                                            <thead >
                                                <tr>
                                                    <th>Tenant Name</th>
                                                    <th>Property</th>
                                                    <th>Unit Code</th>
                                                    <th>Tenant Code</th>
                                                    {dateColumns.map((date) => (
                                                        <th key={date}>{date}</th>
                                                    ))}
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody >
                                                {currentPageData.map((tenant, index) => {
                                                    // Calculate total net sales for the tenant
                                                    const totalNetSales = dateColumns.reduce((total, date) => {
                                                        return total + (tenant.dates[date]?.total_net_sales || 0);
                                                    }, 0);

                                                    return (
                                                        <tr key={index}>
                                                            <td>{tenant.tenant_name}</td>
                                                            <td>{tenant.property_name}</td>
                                                            <td>{tenant.outlet_code}</td>
                                                            <td>{tenant.tenant_code}</td>
                                                            {dateColumns.map((date) => {
                                                                const dateData = tenant.dates[date];
                                                                return (
                                                                    <td key={date} style={{ textAlign: 'center' }}>
                                                                        {dateData ? dateData.total_net_sales.toLocaleString() : '-'}
                                                                    </td>
                                                                );
                                                            })}
                                                            <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                                {totalNetSales.toLocaleString()}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                    {sortedReportData.length > 50 && (
                                        <ReactPaginate
                                            previousLabel={'<<'}
                                            nextLabel={'>>'}
                                            breakLabel={'...'}
                                            breakClassName={'break-me'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={'pages pagination'}
                                            activeClassName={'active'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                        />
                                    )}
                                </Col>
                            </CardBody>
                        </Card>
                    )}
                </Card>
            </Form>
        </Fragment>
    )
}

export default MTDReportView